import React from 'react';

const AnimatedWrapper = ({ children }) => {
  return (
    <div data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
      {children}
    </div>
  );
};

export default AnimatedWrapper;
